"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Card_1 = require("@material-ui/core/Card");
const CardMedia_1 = require("@material-ui/core/CardMedia");
const Grid_1 = require("@material-ui/core/Grid");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const mediaUtil_1 = require("@pbl/pbl-react-core/lib/utils/mediaUtil");
const classnames_1 = require("classnames");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const BonusPoints_1 = require("../bonus-points/BonusPoints");
const VideoModal_1 = require("../earn/VideoModal");
const package_1 = require("../package");
const ImageCardWithPreviewStyle_1 = require("./jss/ImageCardWithPreviewStyle");
const ImageCardWithPreview = ({ videoUrl, imageUrl, bonusCampaign, classes, t }) => {
    const [launchVideo, setLaunchVideo] = React.useState(false);
    const startVideo = () => {
        if (!!videoUrl) {
            setLaunchVideo(true);
        }
    };
    const closeVideo = () => {
        setLaunchVideo(false);
    };
    const imgUrl = !!imageUrl && imageUrl.length > 0
        ? (0, mediaUtil_1.createMediaURL)(package_1.config.internalConfig.BASE_URL, package_1.config.internalConfig.MEDIA_API, imageUrl)
        : package_1.assets.internalAssets.noImage;
    return ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, item: true, xs: 12, md: 6, lg: 6, xl: 4, className: classes.detailCardWrapper }, { children: (0, jsx_runtime_1.jsxs)(Card_1.default, Object.assign({ className: classes.imageCard }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.parentDiv }, { children: [(0, jsx_runtime_1.jsx)(CardMedia_1.default, Object.assign({ image: imgUrl, className: (0, classnames_1.default)({
                                [classes.headerImage]: true,
                                [classes.overlay40]: !!videoUrl
                            }) }, { children: bonusCampaign ? (0, jsx_runtime_1.jsx)(BonusPoints_1.default, { borderRadius: 5 }) : null })), !!videoUrl && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { alt: 'Image Of Play Button', src: package_1.assets.internalAssets.playLogo, color: package_1.config.internalConfig.BUTTON_BACKGROUND, onClick: startVideo, className: classes.playIcon }), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "h6", className: classes.previewText }, { children: t('reward.watchVideo', 'Watch Video') }))] }))] })), (0, jsx_runtime_1.jsx)(VideoModal_1.default, { launchVideo: launchVideo, videoUrl: videoUrl, onClose: closeVideo })] })) })));
};
exports.default = (0, styles_1.withStyles)(ImageCardWithPreviewStyle_1.default)((0, react_i18next_1.withTranslation)()(ImageCardWithPreview));
//# sourceMappingURL=ImageCardWithPreview.js.map